'use strict';

var AppState = require('app_state');
var Misc = require('utils/misc');

var MapFilterView = Marionette.ItemView.extend({
    template: require('components/devices/templates/map/map_filter'),

    serializeData: function () {
        return {
            filter: Misc.hasFilterSet(this.options.filter) ? this.options.filter : undefined,
            isFullScreen: AppState.isFullScreen,
        };
    },
});

module.exports = MapFilterView;
